import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { setClearAllRefusedDatas } from '../../store/ducks/driver/actions';
import { IReasonRefusalDraft } from '../../store/ducks/driver/types';

export default function useRegisterRefusedData() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  async function execute(
    driverId: string,
    data: Array<IReasonRefusalDraft>,
    callback?: any,
  ) {
    try {
      setLoading(true);
      const response = await api.post(
        `v1/backoffice/refused-data/${driverId}`,
        {
          reasonsRefusal: data,
        },
      );

      if (response.status === 201) {
        if (callback) {
          callback();
        }
        toast.success(ToastMessages.refusedData.success.registerRefusedData);
        dispatch(setClearAllRefusedDatas());
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.success(ToastMessages.refusedData.error.registerRefusedData);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
